import React from 'react';
import UrlParse from 'url-parse';
import Loading from '../../components/loading';
import { Row, Button, Table, Space } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import ListLayout from '../../layouts/list-layout';
import { Link } from 'react-router-dom';
import GeneralHelper from '../../helpers/general';

const ENTRY_PER_PAGE = 10000;

class ApiKeyListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount() {
		this.getApiKeys();
	}

	componentDidUpdate(prevProps) {
		const { crf_id: prevCrfId } = prevProps.drawerReducer;
		const { crf_id: newCrfId } = this.props.drawerReducer;
		if(prevCrfId !== newCrfId) {
			this.getApiKeys();
		}
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	onPageChange = (page, limit) => {
		return this.getApiKeys({ page, limit });
	}

	getApiKeys = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const {
			page,
			limit
		} = opts || {};

		this.props.getApiKeys({
			page: page || query.page || 1,
			limit: limit || query.limit || ENTRY_PER_PAGE
		});
	};

	render() {
		const { apiKeys, loading } = this.props.pageProps;
		const columns = [
			{
				title: 'API Key Name',
				dataIndex: 'name',
				key: 'name',
				render: name => GeneralHelper.truncateString(name, 50)
			},
			{
				title: 'Action',
				key: 'action',
				render: data => {
					return (
						<Space size="middle">
							<Link to={`/api-keys/id/basic?id=${data._id}`}> Edit </Link>
						</Space>
					);
				}
			}
		];

		return (
			<>
				<ListLayout
					title="API Keys"
				>
					{ loading ?
						<Loading /> :
						<>
							<Row
								justify="end"
								style={{ paddingBottom: 10, paddingTop: 10, paddingRight: 12 }}
							>
								<Button
									icon={<PlusSquareOutlined />}
									style={{ background: '#003366', color: '#ffffff', marginRight: 10, marginTop: 5 }}
									onClick={() => this.props.history.push('/api-keys/create')}
								>
									New API Key
								</Button>
							</Row>
							<Table
								columns={columns}
								dataSource={apiKeys}
								style={{ width: '100%', marginTop: 5, paddingRight: 20, paddingLeft: 20 }}
								scroll={{ x: 800 }}
							/>
						</>
					}
				</ListLayout>
				<div className="copyright">
					<p>Copyright &copy; The Hong Kong University of Science and Technology. <em>All rights reserved.</em></p>
				</div>
			</>
		);
	}
}

export default ApiKeyListPage;
